var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#DBFFEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 19.4287C38.943 19.4287 44.5713 25.057 44.5713 32C44.5713 38.943 38.943 44.5713 32 44.5713C25.057 44.5713 19.4287 38.943 19.4287 32C19.4287 25.057 25.057 19.4287 32 19.4287ZM32 21.7139C26.3194 21.7139 21.7139 26.3194 21.7139 32C21.7139 37.6806 26.3194 42.2861 32 42.2861C37.6806 42.2861 42.2861 37.6806 42.2861 32C42.2861 26.3194 37.6806 21.7139 32 21.7139ZM35.7627 27.7637C36.2088 27.3171 36.9324 27.3176 37.3789 27.7637C37.8251 28.2097 37.8266 28.9334 37.3809 29.3799L30.3477 36.4199C30.1287 36.6391 29.8293 36.76 29.5195 36.7549C29.2097 36.7497 28.9137 36.6171 28.7021 36.3906L25.3291 32.7812C24.8987 32.3203 24.9224 31.596 25.3828 31.165C25.8438 30.7344 26.568 30.7583 26.999 31.2188L29.5664 33.9639L35.7627 27.7637Z",
    fill: "#008F4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e8a7606c3a566064f0cf52dff84bc839.svg";
export { ForwardRef as ReactComponent };